module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_external_link_small-7cb35ffa46468341a366a213c731c3e3.svg";